import moment from 'moment';

export default function (value, format = 'DD.MM.YYYY hh:mm') {
    if (value == null) {
        return value;
    }
    return moment(value).format(format);
}
